import React from 'react';
import { Button } from '../ui/button';
import { ArrowLeft, Edit, Plus, Trash2, Building2 } from 'lucide-react';

export const ProjectHeader = ({ project, teamMembers, navigate, onEdit, onAddTask, onDeleteRequest }) => (
  <div className="mb-6">
    <Button variant="ghost" onClick={() => navigate('/projects')} className="mb-4">
      <ArrowLeft className="mr-2 h-4 w-4" />
      Back to Projects
    </Button>
    <div className="flex items-start justify-between">
      <div>
        <h1 className="text-4xl font-heading font-bold tracking-tight mb-2">{project.name}</h1>
        {project.project_code && (
          <p className="text-sm text-primary/70 mb-1" data-testid="project-code">{project.project_code}</p>
        )}
        <div className="flex items-center gap-3 flex-wrap">
          {project.client_name && (
            <p className="text-lg text-muted-foreground">{project.client_name}</p>
          )}
          {project.company_name && (
            <span className="text-sm text-muted-foreground flex items-center gap-1">
              <Building2 className="h-4 w-4" /> {project.company_name}
            </span>
          )}
          {project.project_lead && (
            <span className="text-sm text-muted-foreground" data-testid="project-lead-display">
              Lead: {teamMembers.find((m) => m.user_id === project.project_lead)?.name || project.project_lead}
            </span>
          )}
          {project.project_associate && (
            <span className="text-sm text-muted-foreground" data-testid="project-associate-display">
              Associate: {teamMembers.find((m) => m.user_id === project.project_associate)?.name || project.project_associate}
            </span>
          )}
        </div>
      </div>
      <div className="flex gap-2 items-center">
        <span className="px-3 py-1 text-sm font-semibold rounded-full bg-primary/20 text-primary">
          {project.status}
        </span>
        <Button variant="outline" onClick={onEdit}>
          <Edit className="mr-2 h-4 w-4" />
          Edit
        </Button>
        <Button onClick={onAddTask} data-testid="add-task-btn">
          <Plus className="mr-2 h-4 w-4" />
          Add Task
        </Button>
        <Button variant="destructive" onClick={onDeleteRequest} data-testid="delete-project-btn">
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
    {project.description && (
      <p className="text-sm text-muted-foreground mt-3 max-w-3xl" data-testid="project-description">
        {project.description}
      </p>
    )}
  </div>
);
